var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.97219 0 0 8.97219 0 20C0 31.0278 8.97219 40 20 40C31.0278 40 40 31.0278 40 20C40 8.97219 31.0278 0 20 0ZM28.0176 24.4824C28.9941 25.4584 28.9941 27.0416 28.0176 28.0176C27.5299 28.5059 26.8897 28.75 26.25 28.75C25.6103 28.75 24.9701 28.5059 24.4824 28.0176L20 23.5352L15.5176 28.0176C15.0299 28.5059 14.3897 28.75 13.75 28.75C13.1103 28.75 12.4701 28.5059 11.9824 28.0176C11.0059 27.0416 11.0059 25.4584 11.9824 24.4824L16.4648 20L11.9824 15.5176C11.0059 14.5416 11.0059 12.9584 11.9824 11.9824C12.9577 11.0059 14.5423 11.0059 15.5176 11.9824L20 16.4648L24.4824 11.9824C25.4577 11.0059 27.0423 11.0059 28.0176 11.9824C28.9941 12.9584 28.9941 14.5416 28.0176 15.5176L23.5352 20L28.0176 24.4824Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.9d31bee1745c93ba1c5b3ff5c710e7cd.svg";
export { ForwardRef as ReactComponent };